var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<body>\n<div ng-controller=\"MultiFactorAuthenticationController\"></div>\n</body>\n";
var id1="views/mfa.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ../partials/views/mfa.html
// module id = 146
// module chunks = 0